import { PropsWithChildren } from 'react';
import { Container, Global, Paper, Stack } from '@mantine/core';
import { Colors } from '../Utils/Colors.ts';
import { Logo } from '../Logo.tsx';

export interface AuthLayoutProps {
    dontIncludePaper?: boolean;
}

export function AuthLayout({
    dontIncludePaper = false,
    children,
}: PropsWithChildren<AuthLayoutProps>) {
    return (
        <>
            <Global styles={bodyBackgroundColor} />
            <Container my={'2em'}>
                <Container
                    w={containerWidth}
                    px={containerPadding}
                >
                    {dontIncludePaper ? (
                        children
                    ) : (
                        <Paper
                            p={paperPadding}
                            withBorder
                            radius="md"
                            shadow="md"
                        >
                            <Logo />
                            <Stack
                                style={stackMinHeight}
                                justify={'center'}
                            >
                                {children}
                            </Stack>
                        </Paper>
                    )}
                </Container>
            </Container>
        </>
    );
}

const bodyBackgroundColor = {
    body: {
        backgroundColor: Colors.azulOscuro,
    },
};
const containerWidth = { base: '100%', xs: 440 };
const paperPadding = { base: '1em', xs: '2em' };
const containerPadding = { base: 0 };
const stackMinHeight = { minHeight: 200 };
